import React, { KeyboardEventHandler, KeyboardEvent, useEffect, useState } from 'react';
import NativeSelect from '@material-ui/core/NativeSelect';
import Box from '@material-ui/core/Box';

export type ComboBoxItemType = {
  index: number;
  name: string;
  tag?: any; //付加情報
};

type Props = {
  itemList: ComboBoxItemType[] | undefined;
  label: string;
  value?: number;
  itemBoxStyle?: string;
  labelStyle?: string;
  justifyContent?: string;
  onChangeEvent?: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
};

export const ItemComboBox: React.FC<Props> = (props) => {
  return (
    <table>
      <tr>
        <td style={{ padding: '0px' }}>
          <div className={props.labelStyle ?? ''}>{props.label}</div>
        </td>
        <td style={{ padding: '0px' }}>
          <NativeSelect
            onChange={props.onChangeEvent}
            className={props.itemBoxStyle ?? ''}
            value={props.value}
            readOnly
            onKeyPress={(ev) => {
              //console.debug([`NativeSelect onKeyPress ${ev}`]);
              ev.preventDefault();
            }}
            onKeyDown={(ev) => {
              //console.debug([`NativeSelect onKeyDown ${ev}`]);
              ev.preventDefault();
            }}
          >
            {props.itemList?.map((row, index) => (
              <option key={row.index} value={row.index}>{`${row.name}`}</option>
            ))}
          </NativeSelect>
        </td>
      </tr>
    </table>
  );
};
export default ItemComboBox;
